import { supabase } from './client';

// Fonction pour créer une organisation en utilisant une procédure stockée
export const createOrganization = async (userId: string, orgName: string = "Mon Organisation", plan: string = "standard") => {
  console.log(`Tentative de création d'organisation pour l'utilisateur: ${userId}`);
  try {
    // Utiliser la fonction rpc pour appeler la procédure stockée (SQL)
    const { data: orgId, error } = await supabase.rpc('manually_create_organization', {
      p_user_id: userId,
      org_name: orgName,
      plan_name: plan
    });
    
    if (error) {
      console.error('Erreur lors de la création d\'organisation via RPC:', error);
      return { success: false, error: error.message };
    }
    
    console.log('Organisation créée avec succès via RPC:', orgId);
    
    // Sauvegarder l'ID de l'organisation dans localStorage
    if (orgId) {
      localStorage.setItem('currentOrganizationId', orgId);
    }
    
    return { success: true, organizationId: orgId };
  } catch (err) {
    console.error('Exception lors de la création d\'organisation:', err);
    return { success: false, error: err instanceof Error ? err.message : 'Erreur inconnue' };
  }
};

// Fonction pour récupérer l'adhésion à une organisation
export const getUserOrganizationMembership = async (userId: string) => {
  console.log(`Récupération de l'adhésion à l'organisation pour l'utilisateur: ${userId}`);
  try {
    // Utiliser notre fonction RPC sécurisée
    const { data, error } = await supabase.rpc('get_user_organization_safe', {
      p_user_id: userId
    });
    
    if (error) {
      console.error('Erreur lors de la récupération de l\'adhésion via RPC:', error);
      return { success: false, error: error.message, data: null };
    }
    
    console.log('Adhésion récupérée avec succès via RPC:', data);
    // Sauvegarder l'ID de l'organisation dans localStorage
    if (data && data.length > 0) {
      localStorage.setItem('currentOrganizationId', data[0].id);
    }
    return { success: true, data };
  } catch (err) {
    console.error('Exception lors de la récupération de l\'adhésion:', err);
    return { success: false, error: err instanceof Error ? err.message : 'Erreur inconnue', data: null };
  }
};

// Fonction pour récupérer les détails d'une organisation
export const getOrganizationDetails = async (organizationId: string) => {
  console.log(`Récupération des détails de l'organisation: ${organizationId}`);
  try {
    // Utiliser notre fonction RPC sécurisée
    const { data, error } = await supabase.rpc('get_organization_details', {
      p_organization_id: organizationId
    });
    
    if (error) {
      console.error('Erreur lors de la récupération des détails de l\'organisation via RPC:', error);
      return { success: false, error: error.message, data: null };
    }
    
    console.log('Détails de l\'organisation récupérés avec succès via RPC:', data);
    return { success: true, data: data && data.length > 0 ? data[0] : null };
  } catch (err) {
    console.error('Exception lors de la récupération des détails de l\'organisation:', err);
    return { success: false, error: err instanceof Error ? err.message : 'Erreur inconnue', data: null };
  }
};

// Fonction mise à jour pour récupérer les organisations de l'utilisateur sans problème de colonne
export const getUserOrganizations = async (userId: string) => {
  console.log(`Récupération des organisations pour l'utilisateur: ${userId}`);
  try {
    // Utiliser notre fonction RPC sécurisée pour récupérer l'organisation active
    const { data: orgData, error: orgError } = await supabase.rpc('get_user_organization_safe', {
      p_user_id: userId
    });
    
    if (orgError) {
      console.error('Erreur lors de la récupération de l\'organisation via RPC:', orgError);
      
      // Approche alternative utilisant deux requêtes distinctes au lieu d'une sous-requête
      // D'abord, récupérer les IDs des organisations dont l'utilisateur est membre
      const { data: membershipData, error: membershipError } = await supabase
        .from('organization_members')
        .select('organization_id')
        .eq('user_id', userId);
      
      if (membershipError) {
        console.error('Erreur lors de la récupération des appartenances:', membershipError);
        return { success: false, error: membershipError.message, data: null };
      }
      
      // Extraire les IDs des organisations
      const organizationIds = membershipData.map(item => item.organization_id);
      
      // Maintenant, récupérer les organisations avec ces IDs
      const { data, error } = await supabase
        .from('organizations')
        .select('*')
        .in('id', organizationIds);
      
      if (error) {
        console.error('Erreur lors de la récupération des organisations:', error);
        return { success: false, error: error.message, data: null };
      }
      
      console.log('Organisations récupérées avec succès via requête alternative:', data);
      
      // Sauvegarder l'ID de la première organisation dans localStorage si trouvée
      if (data && data.length > 0) {
        localStorage.setItem('currentOrganizationId', data[0].id);
      }
      
      return { success: true, data };
    }
    
    if (!orgData || orgData.length === 0) {
      console.error('Aucune organisation trouvée via RPC');
      return { success: false, error: 'Aucune organisation trouvée', data: null };
    }
    
    console.log('Organisation récupérée avec succès via RPC:', orgData);
    
    // Sauvegarder l'ID de l'organisation dans localStorage
    localStorage.setItem('currentOrganizationId', orgData[0].id);
    
    return { success: true, data: orgData };
  } catch (err) {
    console.error('Exception lors de la récupération des organisations:', err);
    return { success: false, error: err instanceof Error ? err.message : 'Erreur inconnue', data: null };
  }
};
